export default __webpack_public_path__ + "static/media/41.efc736bd.jpg";